import { extendTheme } from "@chakra-ui/react"
import { global } from "./global"
import { fonts } from "./fonts"
import { breakpoints } from "./breakpoints"
import { ButtonStyles } from "./components/ButtonStyles"
import { InputStyles } from "./components/InputStyles"
import { PinInputStyles } from "./components/PinInputStyles"
import { HeadingStyles } from "./components/HeadingStyles"
import { PopoverStyles } from "./components/PopoverStyles"
import { CheckboxStyles } from "./components/CheckboxStyles"
import {
  colors,
  fontSizes,
  borders,
  radii,
  shadows,
  lineHeights,
  widths,
  heights,
} from "./variables"

export const extendedTheme = extendTheme({
  fonts,
  styles: { global },
  colors,
  fontSizes,
  borders,
  radii,
  breakpoints,
  lineHeights,
  shadows,
  sizes: {
    ...widths,
    ...heights,
  },
  components: {
    Button: ButtonStyles,
    Input: InputStyles,
    PinInput: PinInputStyles,
    Heading: HeadingStyles,
    Popover: PopoverStyles,
    Checkbox: CheckboxStyles,
  },
})
